module.exports = __webpack_public_path__ + "assets/8f8c0d7bf9484e1e007aab04672e9158.svg";